import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const SEND_DISCONNECTED_ACCOUNT_EMAIL = createAsyncActionTypes('SEND_DISCONNECTED_ACCOUNT_EMAIL');
export const SEND_REQUEST_ACCESS_EMAIL = createAsyncActionTypes('SEND_REQUEST_ACCESS_EMAIL');